exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-you .review{border:2px solid #d8842e!important}.about-you .feedback{color:#d8842e;font-size:16px}", ""]);

// exports
